import { useSelector } from 'react-redux';
import { useState } from 'react';
import get from 'lodash-es/get';

import { RootState } from 'app/store/rootReducer';
import {
  getMessagesForQuestions,
  getQuestionsValid,
} from 'app/store/data/formsConfig';
import {
  FieldsEnum,
  FormsEnum,
  LabelEnum,
  MessageTypeEnum,
} from 'app/shared/enums';
import { FormRowValidationMessageProps } from 'app/components/FormRowValidationMessage/FormRowValidationMessage.interface';
import { useForm } from 'app/shared/hooks/useForm';
import { CalculationDataByKeysInterface } from 'app/shared/interfaces/CalculationDataByKeys.interface';

export function useMessages(
  questionKeys: FieldsEnum[],
  invalidLocally: boolean,
  formName: FormsEnum
) {
  const { formMeta } = useForm<CalculationDataByKeysInterface>(formName);
  const anyFieldTouchedInStore = questionKeys
    .map((questionKey) => get(formMeta, questionKey))
    .some((meta) => meta !== undefined && meta.touched);

  const questionsValid = useSelector((state: RootState) =>
    getQuestionsValid({
      state,
      formName,
      questionKeys,
    })
  );

  const [touchedLocally, setTouchedLocally] = useState<boolean>(false);
  const valid = questionsValid && !invalidLocally;
  const messages = useSelector((state: RootState) =>
    getMessagesForQuestions({
      state,
      formName,
      questionKeys,
    })
  );
  const visibleNonRequiredErrors = messages.filter(
    (msg) =>
      msg.visible &&
      msg.type === MessageTypeEnum.Danger &&
      !msg.key.includes('$required')
  );
  const touched = touchedLocally || anyFieldTouchedInStore;
  const error = touched && !valid;
  const hasVisibleNonRequiredError = visibleNonRequiredErrors.length > 0;

  const message: FormRowValidationMessageProps['message'] = {
    key: 'allDataRequired',
    visible: touched && invalidLocally && !hasVisibleNonRequiredError,
    content: LabelEnum.FieldAllRequiredData,
    type: MessageTypeEnum.Danger,
  };

  return {
    error,
    message,
    messages,
    setTouchedLocally,
  };
}
